module.exports = __webpack_public_path__ + "static/media/support-svg.35095bed.svg";